// -----------------------------------------------
// SNS
// -----------------------------------------------
$(function() {
  var $librarySnsBtn = $('#js-library-sns-btn'),
      $ibrarySnsList = $('#js-ibrary-sns-list');

  $librarySnsBtn.on('click', function() {
    if($(this).hasClass('is-show')) {
      $(this).removeClass('is-show');
      $ibrarySnsList.fadeOut();
    } else {
      $(this).addClass('is-show');
      $ibrarySnsList.fadeIn();
    }
  });
});

var $reviewModalFormCheck = $('form[name="review_modal_form_check"]');
var $form = $('form[name="review_modal_form"]');
var $formCheck = $('form[name="review_modal_form_check"]');
var $modalComp = $('.review-modal__cnt__form__comp');

var backReviewInput = function() {
	$reviewModalFormCheck.fadeOut(200, function() {
		$form.fadeIn(200);
	});
	$form.find('[type="submit"]').prop('disabled', false);
}

$(function() {
	// モーダル内のフォーム
	// 確認
	$form.submit(function(e) {
		e.preventDefault();
		$form.find('[type="submit"]').prop('disabled', true);
		var data = $form.serialize();
		var url = $form.prop('action');
		$.ajax({
			type: "POST",
			url: url,
			data: data,
			complete: function(XMLHttpRequest, textStatus){
				if(XMLHttpRequest.status == '200') {
					// 確認
					$form.find('.required_text').text('');
					var rate = $form.find('[name="rate"]:checked').val();
					var $star = $reviewModalFormCheck.find('.review_star_radio_confirm');
					$star.removeClass('is-active');
					for (var i = 0; i < rate; i++) {
						$star.eq(i).addClass('is-active');
					}

					$reviewModalFormCheck.find('.js-review_val').text(rate + '.0');
					$reviewModalFormCheck.find('.review_input_text.user_name').text($form.find('[name="user_name"]').val());
					$reviewModalFormCheck.find('.review_input_text.title').text($form.find('[name="title"]').val());
					// text()でエスケープかけてから改行をbrに置換してHTMLとして表示
					var bodyText = $('<span></span>').text($form.find('[name="body"]').val());
					$reviewModalFormCheck.find('.review_input_text.body').html(bodyText.text().replace(/[\n\r]/g, "<br />"));
					$form.find('[type="submit"]').prop('disabled', false);
					$form.fadeOut(200, function(){
						$reviewModalFormCheck.fadeIn(200);

					});

				}else if(XMLHttpRequest.status == '422') {
					// バリデーションエラー
					var errorTexts = JSON.parse(XMLHttpRequest.responseText);
					$form.find('.required_text').text('');
					for (errorField in errorTexts) {
						$form.find('[name="' + errorField + '"]').addClass('is-error');
						$form.find('.required_text.'+errorField).append(errorTexts[errorField][0]);
					}
					$form.find('[type="submit"]').prop('disabled', false);
				}
			}
		});
		return false;
	});

	// 完了
	$formCheck.submit(function(e) {
		e.preventDefault();
		$formCheck.find('[type="submit"]').prop('disabled', true);
		var data = $formCheck.serialize();
		var url = $formCheck.prop('action');
		$.ajax({
			type: "POST",
			url: url,
			data: data,
			complete: function(XMLHttpRequest, textStatus){
				if(XMLHttpRequest.status == '200') {
					// 完了
					$form.find('[type="submit"]').prop('disabled', true);
					$formCheck.fadeOut(200, function(){
						$modalComp.fadeIn(200);
						$('.js-review_modal_btn').addClass('disabled').text('レビュー済');
					});

				}else if(XMLHttpRequest.status == '422') {
					// バリデーションエラー
					var errorTexts = JSON.parse(XMLHttpRequest.responseText);
					$form.find('.required_text').text('');
					for (errorField in errorTexts) {
						$form.find('[name="' + errorField + '"]').addClass('is-error');
						$form.find('.required_text.'+errorField).append(errorTexts[errorField][0]);
					}
					$form.find('[type="submit"]').prop('disabled', false);
					$formCheck.find('[type="submit"]').prop('disabled', false);
					$formCheck.fadeOut(200, function(){
						$form.fadeIn(200);

					});
				}
			}
		});
		return false;
	});

	// LIKEボタン（更新）
	var $btnLike = $('.btn_like');
	var $btnLikeCheckbox = $btnLike.find(':checkbox')
	$btnLikeCheckbox.on('click', function(){
		var libraryId = $(this).val();
		$.get('/api/library/' + libraryId + '/like' , function(data){
			$muchBtnLikeCheckbox = $btnLikeCheckbox.filter("input[value='" + libraryId + "']");
			$muchBtnLikeCheckbox.prop('checked', data.like);
			$muchBtnLikeCheckbox.parent('.btn_like').find('.num').text(data.count);
		});
	});
	// LIKEボタン(状態取得)
	$btnLikeCheckbox.each(function() {
		var libraryId = $(this).val();
		$.get('/api/library/' + libraryId + '/like/status' , function(data){
			$muchBtnLikeCheckbox = $btnLikeCheckbox.filter("input[value='" + libraryId + "']");
			$muchBtnLikeCheckbox.prop('checked', data.like);
			$muchBtnLikeCheckbox.trigger('change');
			$muchBtnLikeCheckbox.parent('.btn_like').find('.num').text(data.count);
		});
	});
});